export default {"src":"/_next/static/media/collateral.bd0cd7f0.svg","height":25,"width":22};